import {
	Alert,
} from 'react-native';
import {
	Button,
	Column,
	Icon,
	Text,
} from 'native-base';
import {
	FontAwesome5,
} from '@expo/vector-icons';
import * as Updates from 'expo-updates';
import {
	deleteCachedFiles,
} from '../functions/CacheSystem';
import testProps from '../OneHat/functions/testProps';
import withRedux from '../OneHat/data/hoc/withRedux';
import ScreenContainer from '../OneHat/components/ScreenContainer';
import getIsMobile from '../OneHat/functions/getIsMobile';
import oneHatData from '@onehat/data';


function Utilities(props) {
	const {
			actions,
		} = props,
		isMobile = getIsMobile(),
		clearOfflineCache = async () => {

			try {

				actions.setProgressMessage('Clearing offline data');
				actions.setProgressPercentage(0);

				const asyncRepositories = oneHatData.getRepositoriesByType('async');
				let i, repository;
				for (i = 0; i < asyncRepositories.length; i++) {
					repository = asyncRepositories[i];
					await repository.clearAll();
				}
				actions.setProgressPercentage(50);

				if (isMobile) {
					const secureRepositories = oneHatData.getRepositoriesByType('secure');
					for (i = 0; i < secureRepositories.length; i++) {
						repository = secureRepositories[i];
						await repository.clearAll();
					}
				}

				await deleteCachedFiles();
				
				if (isMobile) {
					if (Updates && Updates.reloadAsync) {
						await Updates.reloadAsync();
					}
				}
				actions.setProgressPercentage(100);

			} catch (e) {
				actions.setProgressPercentage(100);
				Alert.alert('Error', e);
			}
		};
	
	return <ScreenContainer screenName="Utilities">
				<Column
					flex={1}
					w="280px"
					justifyContent="center"
				>
					<Text>This button clears all of the offline cache on your device.
						Do not use unless instructed to by the support team!</Text>
					<Button
						{...testProps('clearOfflineCacheBtn')}
						leftIcon={<Icon as={FontAwesome5} name="trash" size="sm" />}
						onPress={clearOfflineCache}
						mt={10}
					>Clear Offline Cache</Button>
				</Column>
			</ScreenContainer>;
}

export default withRedux(Utilities);